import { Component } from '@angular/core';

@Component({
  selector: 'fgb-partner-offers-page',
  templateUrl: './partner-offers-page.component.html',
  styleUrls: ['./partner-offers-page.component.scss'],
})
export class PartnerOffersPageComponent {}
